export const OFFERED_TO_CUSTOMER_TYPE = {
  NUMBER_PORTING: 'numberporting',
  NEW_CUSTOMER: 'newcustomer',
  EXISTING: 'existing',
  KEEP: 'keepsubscription'
}

export const OFFER_MESSAGES = {
  [OFFERED_TO_CUSTOMER_TYPE.NUMBER_PORTING]: 'Du flytter dit nummer til Telmore',
  [OFFERED_TO_CUSTOMER_TYPE.NEW_CUSTOMER]: 'Du opretter et nyt nummer hos Telmore',
  [OFFERED_TO_CUSTOMER_TYPE.EXISTING]: 'Du bliver kunde hos Telmore'
}
